import { ImgHTMLAttributes, useState, forwardRef } from 'react';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  priority?: boolean;
  className?: string;
}

const Image = forwardRef<HTMLImageElement, ImageProps>(({ 
  src, 
  alt, 
  width, 
  height, 
  priority = false,
  className = '',
  ...props 
}, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  if (hasError) {
    return (
      <div 
        className={`image-error ${className}`}
        style={{ 
          width: width || 'auto', 
          height: height || 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'transparent',
          color: '#999',
          border: 'none',
          boxShadow: 'none'
        }}
      >
        {alt || 'Image'}
      </div>
    );
  }

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={priority ? 'eager' : 'lazy'}
      onLoad={handleLoad}
      onError={handleError}
      style={{
        opacity: isLoading ? 0 : 1,
        transition: 'opacity 0.3s ease',
        ...props.style
      }}
      {...props}
    />
  );
});

Image.displayName = 'Image';

export default Image;

